import { Box, Skeleton, Typography } from '@mui/material';
import { SelectPlatform } from 'components/common';
import { SelectAdAccounts } from './FacebookFormComponents';
import type { FC } from 'react';
import { Suspense, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

const AdAccountsForm: FC = () => {
  const { trigger, getFieldState } = useFormContext();
  const isDirty = getFieldState('adAccounts').isDirty;

  useEffect(() => {
    if (isDirty)
      void trigger('adAccounts');
  }, [trigger, isDirty]);

  return (
    <>
      <Typography variant="h6" sx={{ mb: 3 }}>
        Ad Accounts & Platform
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          maxWidth: '50%',
          width: '100%',
        }}
      >
        <SelectPlatform />
        <Suspense fallback={
          <Skeleton
            height={40}
            sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
          />
        }>
          <SelectAdAccounts />
        </Suspense>
      </Box>
    </>
  );
};
export default AdAccountsForm;
